import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { BASE_CONSTANTS } from "@tci/common";
import { NgAuthGuardService } from "../ng-shared/ng-services/ng-auth-guard.service";
import { NgUserExceptionsComponent } from "./ng-user-exceptions.component";

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: BASE_CONSTANTS.UNREGISTERED_ERROR,
                component: NgUserExceptionsComponent
            },
            {
                path: BASE_CONSTANTS.DISABLED_ERROR,
                component: NgUserExceptionsComponent
            },
            {
                path: BASE_CONSTANTS.EULA_ERROR,
                canActivate: [
                    NgAuthGuardService
                ],
                component: NgUserExceptionsComponent
            }
        ])
    ],
    exports: [
        RouterModule
    ]
})
export class NgUserExceptionsRoutingModule {
}
